import { render, staticRenderFns } from "./tag-status.vue?vue&type=template&id=76e8e836&scoped=true"
import script from "./tag-status.vue?vue&type=script&lang=js"
export * from "./tag-status.vue?vue&type=script&lang=js"
import style0 from "./tag-status.vue?vue&type=style&index=0&id=76e8e836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8e836",
  null
  
)

export default component.exports